import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend, Label
} from "reactstrap"
import { Preview } from '../../../../../helpers/ui/FileInput'
import { AvForm, AvField } from "availity-reactstrap-validation"

import { Link, Redirect, withRouter } from "react-router-dom"

import apiResponse from '../../../../../services/apiResponse'
import { cancelToken } from '../../../../../services/adapters/kepegawaian/menuService'

import IndexBloc from '../Index/Blocs/IndexBloc'

class CancelView extends Component {
    source
    indexBloc = new IndexBloc()

    constructor(props) {
        super(props)
        this.state = {
            detail: {}
        }
    }

    loadDetail = async () => {
        const query = {
            uuid: this.props.uuid
        }
        await this.indexBloc.fetchDetail(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadDetail()
    }

    componentDidMount() {
        this.setTokenAPI()

        this.indexBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ detail: result.data.response })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })
    }

    render() {
        const { detail } = this.state
        return (
            <Fragment>
                <Container fluid>
                    <Card>
                        <CardBody>
                            <div className="float-end">
                                <Link to='/izinpegawai/dinas.html'>
                                    <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                </Link>
                            </div>
                            <CardTitle>Pembatalan Perjalanan Dinas</CardTitle>
                            <CardSubtitle className="mb-3">
                            </CardSubtitle>
                            <hr />
                            <AvForm
                                className="needs-validation"
                                onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                            >
                                    <Row className="mb-3">
                                        <Label
                                            className="col-md-2 col-form-label"
                                        >
                                            Nomor 
                                        </Label>
                                        <Col md="4">
                                            <AvField 
                                                type="text" 
                                                placeholder="Nomor Perjalanan Dinas"
                                                errorMessage="Masukkan Nomor Perjalanan Dinas"
                                                className="form-control"
                                                name="official_travel_number"
                                                value={detail?.official_travel_number}
                                                readOnly="true" />
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <Label
                                            className="col-md-2 col-form-label"
                                        >
                                            Tanggal Mulai 
                                        </Label>
                                        <Col md="2">
                                            <AvField
                                                name="official_travel_date"
                                                placeholder="Tanggal Perjalanan Dinas"
                                                type="date"
                                                errorMessage="Masukkan Tanggal Perjalanan Dinas"
                                                className="form-control"
                                                readOnly={true}
                                                value={detail?.official_travel_date}
                                                validate={{ required: { value: true } }}
                                            />
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <Label
                                            className="col-md-2 col-form-label"
                                        >
                                            Tanggal Selesai Dinas 
                                        </Label>
                                        <Col md="2">
                                            <AvField
                                                name="official_travel_end_date"
                                                placeholder="Tanggal Selesai Perjalanan Dinas"
                                                type="date"
                                                errorMessage="Masukkan Tanggal Selesai Perjalanan Dinas"
                                                className="form-control"
                                                readOnly={true}
                                                value={detail?.official_travel_end_date}
                                                validate={{ required: { value: true } }}
                                            />
                                        </Col>
                                    </Row>

                                    {detail?.official_travel_oversea == 1 &&
                                        <Fragment>
                                            <Row className="mb-3">
                                                <Label
                                                    className="col-md-2 col-form-label"
                                                >
                                                </Label>
                                                <Col md="3">
                                                    <AvField
                                                        name="official_travel_date"
                                                        type="text"
                                                        readOnly={true}
                                                        value={detail?.official_travel_domicile == 1 ? 'Dalam Kota' : 'Luar Kota'}
                                                        validate={{ required: { value: true } }}
                                                    />
                                                </Col>
                                            </Row>

                                            {detail?.official_travel_domicile == 2 &&
                                                <Fragment>
                                                    <Row className="mb-3">
                                                        <Label
                                                            className="col-md-2 col-form-label"
                                                        >
                                                        Provinsi 
                                                        </Label>
                                                        <Col md="3">
                                                            <AvField
                                                                name="official_travel_date"
                                                                type="text"
                                                                readOnly={true}
                                                                value={detail?.official_travel_province}
                                                                validate={{ required: { value: true } }}
                                                            />
                                                        </Col>
                                                    </Row>
                                                    <Row className="mb-3">
                                                        <Label
                                                            className="col-md-2 col-form-label"
                                                        >
                                                            Kota 
                                                        </Label>
                                                        <Col md="3">
                                                            <AvField
                                                                name="official_travel_date"
                                                                type="text"
                                                                readOnly={true}
                                                                value={detail?.official_travel_city}
                                                                validate={{ required: { value: true } }}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </Fragment>
                                            }

                                        </Fragment>
                                    }

                                    <Row className="mb-3">
                                        <Label
                                            className="col-md-2 col-form-label"
                                        >
                                            Tujuan 
                                        </Label>
                                        <Col md="5">
                                            <AvField
                                                name="official_travel_destination"
                                                placeholder="Tujuan Perjalanan Dinas"
                                                type="textarea"
                                                rows="5"
                                                errorMessage="Masukkan Tujuan Perjalanan Dinas"
                                                className="form-control"
                                                value={detail?.official_travel_destination}
                                                readOnly="true"
                                            />
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <Label
                                            className="col-md-2 col-form-label"
                                        >
                                            Keterangan 
                                        </Label>
                                        <Col md="5">
                                            <AvField
                                                name="official_travel_description"
                                                placeholder="Keterangan Perjalanan Dinas"
                                                type="textarea"
                                                rows="5"
                                                className="form-control"
                                                value={detail?.official_travel_description}
                                                readOnly="true"
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Label className="col-md-2 col-form-label">
                                            Surat Tugas
                                        </Label>
                                        <Col md="5">
                                            <Preview value={detail?.document} col="5" />
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <Label className="col-md-6 col-form-label">
                                            Presensi
                                        </Label>
                                    </Row>

                            </AvForm>
                        </CardBody>
                    </Card>
                </Container>
            </Fragment>
        )
    }
}

export default CancelView